export default {
  menu: null,
  error: false,
  errorMessage: '',
  footerMenu: "",

}